import { render } from "./head.vue?vue&type=template&id=158faad4&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=158faad4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-158faad4"

export default script